import { render } from "./HeroiconsOutlineLocationMarker.vue?vue&type=template&id=5a3118ff"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLocationMarker.vue"]])

export default __exports__